import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartnerWorkspacePage from "@/pages/partner/PartnerWorkspacePage";
export const Route = createFileRoute("/partner/company")({
  head: () =>
    pageHead(
      "Partner Company",
      "Your authorized Partner company workspace.",
      "/partner/company",
      true,
    ),
  component: () => <PartnerWorkspacePage section="company" />,
});
